module.exports = __webpack_public_path__ + "static/media/p0_7.54dba579.png";